import { render, staticRenderFns } from "./PopupAddWasteReason.vue?vue&type=template&id=89f65ce4&scoped=true&"
import script from "./PopupAddWasteReason.vue?vue&type=script&lang=js&"
export * from "./PopupAddWasteReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f65ce4",
  null
  
)

export default component.exports